<template>
	<div>
	<ul class="apply ovw soak soak_1 info">
		<li class="pad">
			<span>单号</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" v-model="model.orderNo" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>泡发口感</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" v-model="model.sopType" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>下单时间</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" :value="model.createTime.replace('T',' ')" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li v-if="model.createdSign" class="pad" style="border-bottom:0">
			<span>签字</span>
		</li>
		<li v-if="model.createdSign" class="pad"><img style="width:100%" :src="'' + model.createdSign" /></li>
		<li class="pad">
			<span>操作人</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" :value="model.createUser" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>门店</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" :value="model.deptID_sname" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>备注</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" :value="model.note" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad" style="border-bottom:0">
			<span>清单</span>
		</li>
	</ul>
		<ul class="record_list2">
			<li style="margin-bottom:0">
				<div>
					<div class="product-item"><img :src="'/userfile/default/picture/' + model.productID_simage" /><span>{{model.productID_sname}}</span><h3>{{model.productNum}}{{model.unit}}<br>剩余：{model.stock}{{model.unit}}</h3></div>
				</div>
			</li>
		</ul>
	<ul class="apply ovw soak soak_1 info">
		<li class="pad" style="border-bottom:0">
			<span>订单状态追踪</span>
			<div class="fr">
			</div>
		</li>
	</ul>
  <ul class="timeLine" style="width:100%">
      <li class="con" v-for="(item2,index2) in model.detail" :key="index2" :class="model.status >= 3 ? '': 'on2'"><p><span>出库<br></span></p><div class="con">{{item2.oper4}}<br>{{item2.oper4Time?item2.oper4Time.replace('T',' '):''}}<br>出库数量：{{item2.productNum}}<br><img v-if="item2.operSign4" style="width:50%" :src="'' + item2.operSign4" /></div></li>
      <li class="con" :class="model.status > 2 ? '': 'on2'"><p><span>包装</span></p><div class="con">{{model.oper3}}<br>{{model.oper3Time?model.oper3Time.replace('T',' '):''}}</div></li>
      <li class="con" :class="model.status > 1 ? '': 'on2'"><p><span>煮制</span></p><div class="con">{{model.oper2}}<br>{{model.oper2Time?model.oper2Time.replace('T',' '):''}}</div></li>
      <li class="con" :class="model.status > 0 ? '': 'on2'"><p><span>剪洗</span></p><div class="con">{{model.oper1}}<br>{{model.oper1Time?model.oper1Time.replace('T',' '):''}}</div></li>
      <li class="con"><p><span>下单</span></p><div class="con">{{model.createUser}}<br>{{model.createTime.replace('T',' ')}}</div></li>
  </ul>
	</div>
</template>

<script>
import querystring from 'querystring';
import {
  OrderDsDetail
} from "@/api/api.js"
export default {
  data () {
    return {
      model:{orderNo:'',createTime:'',status:0,detail:[]}
    }
  },
  methods:{
  },
  created:function(){
    let that = this;
    let options = querystring.parse(location.search.replace('?', ''));
    OrderDsDetail({ID:options.id},function(res){
      that.model = res.model;
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.record_list2{
  margin-bottom: 0;
  margin-top:0;
}
</style>



// WEBPACK FOOTER //
// src/wechat/dfdetail.vue